export default {
  gdpr: {
    wrapper: {
      padding: '1em 0'
    },
    radioButton: {
      display: 'inline-block',
      width: 'auto',
      marginTop: 0,
      marginRight: '1em'
    },
    radioButtonWrapper: {
      display: 'flex',
      alignItems: 'center',
      fontWeight: 'normal'
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/partners/components/Form/styles.js